const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const isEuVersion = BACKEND_URL.split('.')[BACKEND_URL.split('.').length - 1] === 'eu'

export const isDevelopment = BACKEND_URL.startsWith('https://api.dev.interacty')
export const isStaging = BACKEND_URL.startsWith('https://api.stage.interacty')
export const isProduction = BACKEND_URL.startsWith('https://api.interacty')
